import "./languageButton.component.css"
import GermanFlag from "../assets/flags/de_flag.png";
import EnglishFlag from "../assets/flags/en_flag.png";
import { useEffect } from "react";

/**
 * Language button component
 * @param className Additional class names
 * @param children Children elements
 * @param key Further keys
 * @return Language button component
 */
function LanguageButton(
    props: Readonly<{
        className?: string,
        isEnglish: boolean | undefined;
        onToggle: (newValue: boolean) => void;
        [key: string]: any
    }>
) {
    const { className, onToggle, isEnglish, ...overflowProps } = props;

    useEffect(() => {
        localStorage.setItem('lang_en', isEnglish ? 'true' : 'false');
        
    }, [isEnglish]);
    
    return (
        <button
            className={`language-button no-select ${className ?? ""}`}
            style={{ justifyContent: isEnglish ? "flex-end" : "" }}
            onClick={() => onToggle(!isEnglish)}
            aria-label={isEnglish ? "Switch to German" : "Switch to English"}
            {...overflowProps}
        >
            <div className="flex w-100 between flag-container">
                <img
                    src={GermanFlag}
                    height={12}
                    width={20}
                    alt="German flag"
                    className={isEnglish ? "not-used" : ""}
                />
                <img
                    src={EnglishFlag}
                    height={12}
                    width={20}
                    alt="English flag"
                    className={!isEnglish ? "not-used" : ""}
                />
            </div>

            <div className={`swapper ${isEnglish ? "en" : ""}`} />
        </button>
    )
}

export default LanguageButton;